import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';

import AgentCreate from "./agents/AgentCreate";
import DepartmentCreate from "./departments/DepartmentCreate";
import DepartmentEdit from "./departments/DepartmentEdit";
import AgentEdit from "./agents/AgentEdit";
import AvatarChoose from "./agents/AvatarChoose";
import ChatTransfer from "./chat/ChatTransfer";
import UserBan from "./chat/UserBan";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class BModal extends Component {

    constructor(props) {
        super(props);


        this.handleClose = this.handleClose.bind(this);
    }

    handleClose = () => {
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show":false,
                "page":"",
                "size":""
            }
        });
    }
    render() {
        const { t } = this.props;

        return (
            <Modal
                scrollable={true}
                show={this.props.chatprop.modal.show}
                size={this.props.chatprop.size!="" ? this.props.chatprop.size : this.props.size}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={this.handleClose}
            >
                {this.props.chatprop.modal.page == "addAgent" &&
                        <AgentCreate/>
                }
                {this.props.chatprop.modal.page == "editAgent" &&
                     <AgentEdit/>
                }
                {this.props.chatprop.modal.page == "chooseAvatar" &&
                        <AvatarChoose/>
                }
                {this.props.chatprop.modal.page == "addDepartment" &&
                         <DepartmentCreate/>
                }
                {this.props.chatprop.modal.page == "editDepartment" &&
                        <DepartmentEdit/>
                }
                {this.props.chatprop.modal.page == "chatTransfer" &&
                         <ChatTransfer/>
                }
				{this.props.chatprop.modal.page == "userBan" &&
                         <UserBan/>
                }



            </Modal>

        );
    }
}

export default withTranslation()(BModal);
